import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import { message } from 'antd';
import moment from 'moment';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import ventaUtilidad from '../../../service/ventas/ventaUtilidad';
import establecimientoService from '../../../service/administracion/establecimientoService';
import productoService from '../../../service/administracion/productoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            establecimientos: [],
            tipoProductos: [{ id: 0, nombre: 'TODO' }, { id: 2, nombre: 'SERVICIO' }, { id: 1, nombre: 'PRODUCTO' }],
            almacenes: [],
            monedas: [],
            productos: [],
            productosAll: [],
            vendedores: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                flagNotaVenta: false,
                flagIGV: false,
                idTipoProducto: 0,
                tipoProducto: '',
                producto: '',
                idProducto: 0,
                idEstablecimiento: 0,
                idAlmacen: 0,
                idVendedor: 0,
                establecimiento: '',
                almacen: '',
                tipoReporte: 1,
                referencia: '',
                ...FILTER
            },
            texto: '',
            columnVisible: {
                establecimiento: 'show',
                codigoReferencia: 'hide',
                nombre: 'hide',
                detallado: 'hide',
                cantidad: 'hide',
                vendedor: 'hide',
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            flagNotaVenta: false,
            idTipoProducto: 0,
            tipoProducto: '',
            producto: '',
            flagIGV: false,
            idProducto: 0,
            idEstablecimiento: 0,
            idAlmacen: 0,
            idVendedor: 0,
            establecimiento: '',
            almacen: '',
            tipoReporte: 1,
            referencia: '',
            ...FILTER
        };
        this.setState({ filter });
        setTimeout(() => {
            this.handlePagination();
        }, 500);
    };

    handleChange = async (property, value, label) => {

     const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };

        const { fechaInicioStr, fechaFinStr } = filter;

        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
            const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
            const fin = moment(fechaFinStr, 'DD/MM/YYYY');

            const meses = fin.diff(inicio, 'months', true);

            if (meses > MAX_MESES) {
                message.error('El rango máximo permitido es de 18 meses');
                return; // ⛔ no actualiza el estado
            }
        }

        this.setState({ filter: filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: 0, establecimiento: label },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
        if (property === "idTipoProducto") {
            filter.idProducto = 0;
            filter.idTipoProducto = value;
            filter.tipoProducto = label;
            const tipoProducto = (value == 0 ? this.productos : this.state.productosAll.filter(p => p.idTipoProducto == value));
            this.setState({
                filter: filter,
                productos: tipoProducto ? tipoProducto : [],
            });
        }
        if (property === "idProducto") {
            filter.producto = label;
            this.setState({
                filter: filter,
            });
        }
        if (property === "idAlmacen") {
            filter.almacen = label;
            this.setState({
                filter: filter,
            });
        }

        if (property === "tipoReporte") {
            setTimeout(() => {
                this.setState({
                    filter: {
                        ...this.state.filter,
                        ...FILTER
                    }
                });
            }, 100);
        }


    };

    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaUtilidad.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined) {

                var nombre = '';
                switch (this.state.filter.tipoReporte) {
                    case 1:
                        nombre = 'Reporte de Ventas por Establecimiento.xlsx';
                        break;
                    case 2:
                        nombre = 'Reporte de Ventas por Producto.xlsx';
                        break;
                    case 3:
                        nombre = 'Reporte de Ventas Detallado.xlsx';
                        break;
                    case 4:
                        nombre = 'Reporte de Ventas por Vendedor.xlsx';
                        break;
                    default:
                        nombre = 'Reporte'
                        break;
                }
                global.dowloadFile(response.data, nombre);

            }
        });
    };

    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaUtilidad.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined) {
                var nombre = '';
                switch (this.state.filter.tipoReporte) {
                    case 1:
                        nombre = 'Reporte de Ventas por Establecimiento.pdf';
                        break;
                    case 2:
                        nombre = 'Reporte de Ventas por Producto.pdf';
                        break;
                    case 3:
                        nombre = 'Reporte de Ventas Detallado.pdf';
                        break;
                    case 4:
                        nombre = 'Reporte de Ventas por Vendedor.pdf';
                        break;
                    default:
                        nombre = 'Reporte'
                        break;
                }
                global.dowloadFile(response.data, nombre);

            }
        });

    };

    handleExportPdfRegistrado = async () => {
        this.setState({
            loadingPdfRegistrado: true,
            filter: {
                ...this.state.filter, flagRegistrado: true
            }
        }, async () => {
            var response = await ventaUtilidad.pdf(this.state.filter);
            this.setState({ loadingPdfRegistrado: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Establecimiento (Registrados).pdf");
        });
    };

    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible,
                    establecimiento: 'show',
                    codigoReferencia: (this.state.filter.tipoReporte == 2 || this.state.filter.tipoReporte == 3) ? 'show' : 'hide',
                    nombre: (this.state.filter.tipoReporte == 2 || this.state.filter.tipoReporte == 3) ? 'show' : 'hide',
                    cantidad: (this.state.filter.tipoReporte == 2 || this.state.filter.tipoReporte == 3) ? 'show' : 'hide',
                    detallado: this.state.filter.tipoReporte == 3 ? 'show' : 'hide',
                    vendedor: (this.state.filter.tipoReporte == 4 || this.state.filter.tipoReporte == 3) ? 'show' : 'hide',
                },
            })
        });
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, ventaUtilidad.paginacion);
        const establecimientos = await establecimientoService.principales();
        const productos = await productoService.listar();
        const vendedores = await vendedorService.listar();

        this.setState({
            loadingSource: false,
            establecimientos: establecimientos ? establecimientos : [],
            productos: productos ? productos : [],
            productosAll: productos ? productos : [],
            vendedores: vendedores ? vendedores : [],
        });
    }

    render() {
        return (
            <div>
                <Header
                    title={"Reporte de utilidad bruta"}
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    productos={this.state.productos}
                    tipoProductos={this.state.tipoProductos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    vendedores={this.state.vendedores}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onChange={this._handleChangePagination}
                    texto={this.state.filter.flagIGV ? 'Precio Unitario' : 'Valor Unitario'}

                />
            </div>
        )
    }
}